import { PairBoostersBadgeSkeleton } from '@root/entities/pair/ui/pair-information/pair-boosters-badge'
import { Skeleton } from '@root/shared/ui-kit'

import {
  Address,
  Icon,
  Info,
  InfoTop,
  Name,
  Root,
  Ticker,
} from './premium-card-header'

type Props = {}

export const PremiumCardHeaderSkeleton: React.FC<Props> = () => {
  return (
    <Root>
      <Skeleton width={42} height={42} variant="circular" />
      <Info>
        <InfoTop>
          <Name ellipsis>
            <Skeleton.Line uppercase width={'13ch'} />
          </Name>
          <Skeleton height={14} width={36} />
          <PairBoostersBadgeSkeleton />
        </InfoTop>
        <Address type="button">
          <Ticker>
            <Skeleton.Line uppercase width={'3ch'} />
          </Ticker>
          <Skeleton.Line uppercase width={'10ch'} />
          <Icon>
            <Skeleton height={12} width={12} />
          </Icon>
        </Address>
      </Info>
    </Root>
  )
}
